<template>
    <div class="hidden-template" ref="downloadTemplate">
    <div class="container">
    <div class="content">
        <div class="top-flex">
        <div class=""></div>
        <img src="@/assets/woven.svg" class="woven-logo">
        </div>
        <div class="qrandtext">
        <img v-if="qrPaymentDetails.qrcode" :src="qrPaymentDetails.qrcode" class="qrcode">
        <img v-else-if="qrPaymentDetails.qr_code" :src="qrPaymentDetails.qr_code" class="qrcode">
        <div class="iconsandpay">
            <img src="@/assets/payment link asset png.png" class="paytext">
            <div class="">
                <img src="@/assets/icon1.png" class="icons">
                <img src="@/assets/icon2.png" class="icons">
                <img src="@/assets/icon3.png" class="icons">
            </div>
        </div>
        </div>
        <div class="namecont">
            <div class="howtopay" v-if="qrPaymentDetails.account_number && qrPaymentDetails.bank_name">
                <div class="">How to pay</div>
                <div class="">1. Open your camera or QR scanner to reveal the account details.</div>
                <div class="">2. Or, enter account details to pay</div>
            </div>
            <div class="howtopay" v-else-if="qrPaymentDetails.slug">
                <div class="">How to pay</div>
                <div class="">1. Scan the QR code with your camera or QR app to complete payment.</div>
                <div class="">2. Or, enter account details to pay</div>
            </div>
            <div class="nameandacc">
                <div class="">Account no.</div>
                <div class="">Bank</div>
                <div class="">Merchant Name</div>
            </div>
            <div class="nameandaccno" v-if="qrPaymentDetails.account_number && qrPaymentDetails.bank_name">
                <div class="">{{ qrPaymentDetails.account_number }}</div>
                <div class="">{{ qrPaymentDetails.bank_name }}</div>
                <div :class='(qrPaymentDetails.business_name || qrPaymentDetails.merchant_name).length > 22 ? "sm-name" : ""'>{{ qrPaymentDetails.business_name || qrPaymentDetails.merchant_name}}</div>
            </div>
            <div class="nameandaccno" v-else-if="qrPaymentDetails.slug">
                <div class="">{{ qrPaymentDetails.vnuban }}</div>
                <div class="">{{ qrPaymentDetails.bank }}</div>
                <div :class='(qrPaymentDetails.business_name || qrPaymentDetails.merchant_name).length > 22 ? "sm-name" : ""'>{{ qrPaymentDetails.business_name || qrPaymentDetails.merchant_name}}</div>
            </div>
        </div>
        <div class="authenticity">
            <img src="@/assets/star.png" class="star">
            For authenticity, check the Woven Verified Seal or QR code
            <img src="@/assets/star.png" class="star">
        </div>
    </div>
    <img src="@/assets/watermark.png" class="watermark">
    </div>
  </div>
  </template>
  <script>
  import FileSaver from "file-saver";
  import html2canvas from "html2canvas";
  export default {
  props: {
  qrPaymentDetails: {
    required: true
  },
  download: {
    required: true
  }
  },
  methods: {
  downloadQR() {
    this.$notify({
      group: "notifications-default",
      type: "info text-white",
      title: "Info",
      text: "Processing QR template download",
    });
    const template = this.$refs.downloadTemplate;
    template.style.display = 'block';
    html2canvas(template, {
      backgroundColor: "#000000",
      scale: 2,
      useCORS: true,
      logging: false
    }).then(canvas => {
      canvas.toBlob(blob => {
      FileSaver.saveAs(blob, `${this.qrPaymentDetails.account_number ? this.qrPaymentDetails.account_name + ' QR code' : this.qrPaymentDetails.merchant_name +' payment link'}`);
        this.$emit('downloadedqr');
        template.style.display = 'none';
      });
    }).catch(error => {
      this.$notify({
        group: "notifications-default",
        type: "error text-white",
        title: error.message ? error.message : 'Error',
        text: "An error occurred while downloading QR template",
      });
      template.style.display = 'none';
    });
  }
  },
  watch: {
  download: {
    handler() {
      this.$nextTick(() => {
        this.download && this.downloadQR();
      });
    },
    immediate: true
  }
  }
  }
  </script>
  <style lang="scss" scoped>
  .qr-container {
  width: 100%;
  }
  .qr-container .scan-desk {
  font-size: 24px;
  font-weight: 400;
  }
  
  .qr-page-details {
  display: flex;
  width: 100%;
  background: #ffffff;
  justify-content: space-between;
  height: 100%;
  padding: 20px;
  }
  
  .qr-page-details > div {
  display: flex;
  align-items: center;
  justify-self: flex-end;
  gap: 20px;
  }
  
  .qr-page-details > div > main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  }
  
  .qr-page-details > div > main > p {
  width: fit-content;
  }
  
  .qr-page-details > main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  }
  
  .qr-page-details > main > p {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  }
  
  .qr-page-details > main > p span {
  background-color: #FCEFF3;
  width: fit-content;
  color: #e00b5b;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  }
  
  .no-qr {
  font-family: "Calibre", serif !important;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  }
  
  .no-qr__content {
  display: flex;
  flex-direction: column;
  max-width: 330px !important;
  }
  
  .page {
  background: #ffffff;
  border-radius: 6px;
  }
  
  .cursor-pointer {
  cursor: pointer;
  }
  
  .hidden-template {
  position: absolute;
  left: -9999px;
  top: -9999px;
  display: none;
  }
  
  .hidden-template * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: Lato, sans-serif;
  color: #1B2A6D;
  }
  
  .hidden-template .container {
  height: 675px;
  width: 900px;
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;
  }
  
  .hidden-template .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100% !important;
  height: 100%;
  background-color: #E00B5B;
  padding: 30px 30px;
  position: relative;
  }
  
  .hidden-template .top-flex {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  }
  
  .hidden-template .woven-logo {
  height: 60px;
  justify-self: flex-end;
  }
  
  .hidden-template .scanlink {
  width: 100%;
  justify-self: center;
  transform: scale(0.8);
  }
  
  .hidden-template .qrandtext {
  display: grid;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  margin-top: -30px;
  }
  .hidden-template .qrcode {
  width: 340px;
  height: 340px;
  justify-self: center;
  }
  .hidden-template .paytext {
  width: auto;
  height: 200px;
  justify-self: flex-end;
  position: relative;
  top: 0;
  left: 0;
  z-index: 10;
  }
  .iconsandpay{
      display: flex;
      flex-direction: column;
      gap: 20px;
  }
  .iconsandpay .icons{
      height: 60px;
      width: 60px;
  }
  .iconsandpay >div{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      margin-left: 80px;
  }
  .hidden-template .namecont {
      display: grid;
      grid-template-columns: 1fr 1fr 2fr;
      width: 100%;
      background-color: white;
      margin-top: 20px;
      position: relative;
      top: 0;
      left: 0;
      z-index: 10;
  }
  .howtopay{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 12px;
      padding: 18px;
  }
  .howtopay >div:first-child{
      text-transform: uppercase;
      color: #1B2A6D;
      text-align: center;
      font-weight: 900;
      font-size: 18px;
  }
  .howtopay >div:nth-child(2),.howtopay >div:nth-child(3){
      color: #1B2A6D;
      text-align: center;
      font-weight: 700;
      font-size: 14px;
  }
  .nameandacc {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-left: 2px solid #1B2A6D;
      border-right: 2px solid #1B2A6D;
      text-transform: uppercase;
      font-weight: 900;
      font-size: 20px;
  }
  .nameandacc >div:first-child{
      width: 100%;
      height: 55%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40% !important;
  }
  .nameandacc >div:nth-child(2){
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30% !important;
      border-bottom: 2px solid #1B2A6D;
      border-top: 2px solid #1B2A6D;
  }
  .nameandacc >div:last-child{
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30% !important;
  }
  .nameandaccno {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
  }
  .nameandaccno >div:first-child{
      font-weight: 900;
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 48px;
      letter-spacing: 4px;
      font-style: italic;
      height: 40% !important;
  }
  .nameandaccno >div:nth-child(2){
      letter-spacing: 2px;
      font-size: 22px;
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      height: 30% !important;
      border-bottom: 2px solid #1B2A6D;
      border-top: 2px solid #1B2A6D;
  }
  .nameandaccno >div:last-child{
      letter-spacing: 2px;
      font-size: 22px;
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-weight: 600;
      background-color: #1B2A6D;
      height: 30% !important;
  }
  .authenticity{
      letter-spacing: 1px;
      width: 100%;
      margin-top: 20px;
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-weight: 500;
      gap: 20px;
  }
  .star{
      height: 20px;
  }
  .watermark{
      position: absolute;
      top: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      opacity: 0.08;
      z-index: 0;
  }
  .sm-name{
    font-size: 16px !important;
  }
  </style>
  